import styled from 'styled-components';
import {Box, Flex, Text, mediaQueries, Script as SliceScript } from '@lce/slice';
import { Container as StyledContainer } from '../../ui';

export const ComboBanner = styled(Box)`
  background-color: ${({theme}) => theme.colors.orange};
`;

export const Container = styled(StyledContainer)`
  padding: 0 8px;

  ${mediaQueries[1]} {
    padding: 0 20px 0 0;
  }
`;

export const FlexContainer = styled(Flex)`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mediaQueries[1]} {
    flex-direction: row;
    justify-content: flex-start;
  }
`;

export const ImageWrapper = styled(Box)`
  flex: 2 0 auto;
  align-self: flex-start;
  justify-self: flex-end;
  margin: 0 auto;

  ${mediaQueries[1]} {
    order: 1;
    margin-bottom: 0;
  }
`;

export const TitleContainer = styled(Flex)`
  flex-direction: column;
  margin-top: 24px;
  padding-left: 0;

  ${mediaQueries[1]} {
    padding-left: 20px;
  }
`;

export const Script = styled(SliceScript)`
  margin-top: -58px;
  display: block;
  text-align: center;

  ${mediaQueries[1]} {
    margin-top: -74px;
    text-align: left;
  }
`;

export const TextSymbol = styled.sup`
  font-size: 1rem;
`;

export const LowerContent = styled(Box)`
  text-align: center;

  ${mediaQueries[1]} {
    margin-top: -20px;
    margin-left: 50px;
  }
`;

export const ComboText = styled(Text)`
  font-family: ${({ theme }) => theme.fonts.mrEaves};
  font-size: 36px;
  text-align: center;
  margin-bottom: 12px;
  line-height: 34px;

  ${mediaQueries[1]} {
    text-align: left;
  }
`;

export const Legal = styled(Text)`
  padding: 0 0 8px 0;
  font-size: 0.75rem;
  line-height: 1.08;
  max-width: 856px;
  margin-top: 32px;

  ${mediaQueries[1]} {
    padding-bottom: 16px;
    padding-left: 20px;
  }
`;
